import { Box } from '@wix/design-system';
import { WixLogo } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
export const ResellerCoBrandedLogo = _ref => {
  let {
    logo,
    logoHeight = '24px',
    wixLogoHeight = '17px',
    wixLogoWidth
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "reseller-logo",
    height: logoHeight
  }), /*#__PURE__*/React.createElement(Box, {
    marginRight: "SP1",
    fontSize: "14px",
    color: "#000624",
    fontWeight: "bold"
  }, "\xD7"), /*#__PURE__*/React.createElement(WixLogo, {
    skin: "dark",
    height: wixLogoHeight,
    width: wixLogoWidth
  }));
};
//# sourceMappingURL=ResellerCoBrandedLogo.js.map